import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseClient } from '../BaseClient';
export class GeneratedTextClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createGeneratedPersonality", void 0);
    _defineProperty(this, "createGeneratedIntro", void 0);
  }
  async generatePersonality(traits, personality) {
    try {
      for (var _len = arguments.length, extraParam = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        extraParam[_key - 2] = arguments[_key];
      }
      const {
        text
      } = await this.request(this.createGeneratedPersonality({
        traits,
        personality
      }), ...extraParam);
      return this.convertToEntity(text);
    } catch (error) {
      this.logError('generatePersonality', 'Failed to generate personality', {
        traits,
        personality
      }, error);
      throw error;
    }
  }
  async generateIntro(assistantName, traits) {
    try {
      for (var _len2 = arguments.length, extraParam = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        extraParam[_key2 - 2] = arguments[_key2];
      }
      const {
        text
      } = await this.request(this.createGeneratedIntro({
        assistantName,
        traits
      }), ...extraParam);
      return this.convertToEntity(text);
    } catch (error) {
      this.logError('generateIntro', 'Failed to generate personality', {
        assistantName,
        traits
      }, error);
      throw error;
    }
  }
  convertToEntity(text) {
    if (!text) {
      throw new Error('Failed to generate text');
    }
    return text.replace(/"/g, '');
  }
  getServiceNameForLogs() {
    return 'GeneratedTextClient';
  }
}
//# sourceMappingURL=GeneratedTextClientBase.js.map